import React from "react";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { List, Row, Col} from "@pankod/refine-antd";
import {SeedingUploadCsvModal} from "./components/seeding-upload-csv.modal";
import {AgenticUploadXlsxModal} from "./components/agentic-upload-xlsx.modal";

export const SeedingList: React.FC<IResourceComponentsProps> = () => {
    return (
        <List title="Seeding" pageHeaderProps={{ extra: <></> }}>
            <Row gutter={[16, 16]}>
                <Col lg={24} xs={24}>
                    <SeedingUploadCsvModal
                        label="Bulk Import And Sync Vendor"
                        apiPath="/vendor-management/bulk-csv-upload"
                        sampleCsvPath="/vendor-management/sample-csv"
                    />
                </Col>
                <Col lg={24} xs={24}>
                    <SeedingUploadCsvModal
                        label="Bulk Import And Sync Expense Category"
                        apiPath="/expense-category/bulk-csv-upload"
                        sampleCsvPath="/expense-category/sample-csv"
                    />
                </Col>
                <Col lg={24} xs={24}>
                    <AgenticUploadXlsxModal
                        label="Agentic Seeding"
                    />
                </Col>
            </Row>
        </List>
    );
};
